export default "__VITE_ASSET__c9b304da__"